import React from "react";
import { EmptyModal, Table } from "../../../../components/core";

export default function ViewVerificationHistoryModal({
	open,
	onClose,
	data = [],
	headers = [
		{ header_name: "Verified Status", header_key: "verifiedStatus" },
		{ header_name: "Msg to User", header_key: "userStatusComments" },
		{ header_name: "Private Comment", header_key: "verifiedStatusComments" },
		{ header_name: "Status Date", header_key: "createdAt" },
	],
}) {
	return (
		<EmptyModal open={open} onClose={onClose}>
			<p className="font-bold text-xl text-center mb-2">
				Current User Verification History
			</p>
			<Table headers={headers} items={data} />
		</EmptyModal>
	);
}
